import { memo } from 'react'
import { FC } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { WithTagname } from 'interfaces/feed'
import NavigationRedirect from 'components/atoms/navigation/NavigationRedirect'
import { FeedTagPageInner } from 'components/features/socialFeed/FeedTagPage/FeedTagPageInner'
import { OnboardingStepGuard } from 'components/features/pfm/OnboardingStepGuard/OnboardingStepGuard'
import { FeedGuard } from 'components/features/socialFeed/FeedGuard/FeedGuard'

export type FeedTagPageProps = Pick<RouteComponentProps<WithTagname>, 'match'>

export const FeedTagPage: FC<FeedTagPageProps> = memo((props) => {
  const { match } = props

  const tagName = match.params.tagName

  if (!tagName) {
    return (
      <NavigationRedirect to='feedposts' />
    )
  }

  return (
    <FeedGuard>
      <OnboardingStepGuard>
        <FeedTagPageInner type='tag' name={ tagName } />
      </OnboardingStepGuard>
    </FeedGuard>
  )
})
